import { SkuCardTrendingPercentProps } from '@/types/props/components/skus';
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LoadingComponent from '../../LoadingComponent';
import { FaCaretDown, FaCaretUp } from 'react-icons/fa';

export default function SkuCardTrendingPercent({
  sku,
  trendingPercent,
  isBadge = true,
}: SkuCardTrendingPercentProps) {
  if (sku === null) {
    if (isBadge) {
      return (
        <span className="tw-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-ask-100 tw-text-ask-800">
          <span>--%</span>
        </span>
      );
    } else {
      return (
        <LoadingComponent
          loading={true}
          componentProps={{
            className: 'text-secondary px-3 py-2 tw-text-base max-nine:!tw-text-xs-custom tw-px-0',
          }}
        >
          <span>--%</span>
        </LoadingComponent>
      );
    }
  }

  if (!isBadge) {
    return (
      <>
        {trendingPercent > 0 && (
          <div className="text-success tw-px-0 tw-py-2 tw-text-base max-nine:!tw-text-xs-custom">
            <FontAwesomeIcon
              icon={faCaretUp}
              className={`me-1 max-[453px]:!tw-m-0 max-[453px]:!tw-p-0`}
            />
            <span>{trendingPercent} %</span>
          </div>
        )}
        {(trendingPercent === 0 || !trendingPercent) && (
          <div className="text-secondary tw-px-0 tw-py-2 tw-text-base max-nine:!tw-text-xs-custom">
            <span>--%</span>
          </div>
        )}
        {trendingPercent < 0 && (
          <div className="text-danger tw-px-0 tw-py-2 tw-text-base max-nine:!tw-text-xs-custom">
            <FontAwesomeIcon
              icon={faCaretDown}
              className={`me-1 max-[453px]:!tw-m-0 max-[453px]:!tw-p-0`}
            />
            <span>{trendingPercent} %</span>
          </div>
        )}
      </>
    );
  }

  if (trendingPercent === 0) {
    return (
      <span className="tw-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-ask-100 tw-px-1 tw-text-base tw-font-medium tw-text-ask-800 max-nine:tw-text-xs-lower">
        <span>--%</span>
      </span>
    );
  }

  if (trendingPercent > 0) {
    return (
      <span className="tw-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-mint-frost tw-px-1 tw-text-base tw-font-medium tw-text-bid-600 max-nine:tw-max-w-fit max-nine:tw-px-2 max-nine:tw-text-xs-lower">
        <FaCaretUp className="me-1" />
        <span>{trendingPercent} %</span>
      </span>
    );
  }

  return (
    <span className="tw-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-red-100 tw-px-1 tw-text-base tw-font-medium tw-text-red-600 max-nine:tw-text-xs-lower">
      <FaCaretDown className="me-1" />
      <span>{trendingPercent} %</span>
    </span>
  );
}
